import { z } from 'zod'

export const userSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  practice: z.number(),
})

export type User = z.infer<typeof userSchema>
